import { Message } from 'element-ui'

const getDefaultState = () => {
  const jdDataUrl = localStorage.getItem('jd')
  const cvDataUrl = localStorage.getItem('cv')

  return {
    interviewDuration: 0,
    interviewLanguage: '', // 新增：存储面试语言
    usingBeautifys: [],
    usingFilter: null,
    usingBackground: null,
    interviewStarted: false,
    interviewScore: 0,
    body_language: 0,
    facial_expression: 0,
    grooming: 0,
    interview_tone: 0,
    timely_response: 0,
    content: 0,
    interviewId: '',
    jd: jdDataUrl ? dataUrlToFile(jdDataUrl, 'job_description.txt') : null,
    cv: cvDataUrl ? dataUrlToFile(cvDataUrl, 'resume.pdf') : null,
    dialogues: [],
    firstDialogue: true,
    prompt: null,
    formattedDialogues: '', // 新增格式化后的对话文本
    rawDialogues: []        // 新增原始对话数据备份
  }
}

// 将 Data URL 转换为 File 对象的辅助函数
function dataUrlToFile(dataUrl, originalFileName) {
  const arr = dataUrl.split(',')
  const mime = arr[0].match(/:(.*?);/)[1]
  const bstr = atob(arr[1])
  let n = bstr.length
  const u8arr = new Uint8Array(n)
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }
  return new File([u8arr], originalFileName, { type: mime })
}

const state = getDefaultState()

const mutations = {
  SET_FORMATTED_DIALOGUES: (state, formattedText) => {
    state.formattedDialogues = formattedText
  },
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState())
  },
  SET_INTERVIEW_DURATION: (state, duration) => {
    state.interviewDuration = duration
  },
  SET_INTERVIEW_LANGUAGE: (state, language) => { // 新增：设置面试语言
    state.interviewLanguage = language
  },
  SET_USING_BEAUTIFYS: (state, beautifys) => {
    state.usingBeautifys = beautifys
  },
  SET_USING_FILTER: (state, filter) => {
    state.usingFilter = filter
  },
  SET_USING_BACKGROUND: (state, background) => {
    state.usingBackground = background
  },
  SET_PROMPT(state, prompt) {
    state.prompt = prompt
  },
  SET_INTERVIEW_STARTED: (state, started) => {
    state.interviewStarted = started
    if (started) {
      state.interviewScore = 0
      state.body_language = 0
      state.facial_expression = 0
      state.grooming = 0
      while (state.dialogues.length > 0) { state.dialogues.pop() }
      state.firstDialogue = true
    }
  },
  SET_INTERVIEW_SCORE: (state, data) => {
    const { score, body_language, facial_expression, grooming, interview_tone, timely_response, content } = data
    state.interviewScore = score
    state.body_language = body_language
    state.facial_expression = facial_expression
    state.grooming = grooming
    state.interview_tone = interview_tone
    state.timely_response = timely_response
    state.content = content
  },
  SET_INTERVIEW_ID: (state, id) => {
    state.interviewId = id
  },
  SET_JD: (state, jd) => {
    state.jd = jd
    // 将 File 对象转换为 Data URL
    const reader = new FileReader()
    reader.onloadend = () => {
      localStorage.setItem('jd', reader.result)
    }
    reader.readAsDataURL(jd)
  },
  SET_CV: (state, cv) => {
    state.cv = cv
    // 将 File 对象转换为 Data URL
    const reader = new FileReader()
    reader.onloadend = () => {
      localStorage.setItem('cv', reader.result)
    }
    reader.readAsDataURL(cv)
  },
  SET_DIALOGUES: (state, dialogue) => {
    if (state.firstDialogue) {
      state.firstDialogue = false
    } else {
      state.dialogues.push(dialogue)
      state.rawDialogues.push(dialogue) // 备份原始数据
    }
  },
  CLEAR_DIALOGUES: (state) => {
    while (state.dialogues.length > 0) state.dialogues.pop()
    state.rawDialogues = []         // 清除原始数据
    state.formattedDialogues = ''    // 清除格式化文本
  }
}

const actions = {
  formatDialogues({ commit, state }) {
    return new Promise((resolve) => {
      const formattedText = state.rawDialogues.reduce((acc, item) => {
        const normalizedUserId = item.userId.replace(/[＿_]/g, '')
        const isInterviewer = normalizedUserId === "RobotMan"
        const prefix = isInterviewer ? '[面试官] ' : '[候选人] '
        return acc + `${prefix}${item.text}\n`
      }, '').trimEnd() // 修复3：移除末尾换行符
      commit('SET_FORMATTED_DIALOGUES', formattedText)
      resolve(formattedText)
    })
  },
  setInterviewDuration({ commit }, duration) {
    return new Promise((resolve, reject) => {
      commit('SET_INTERVIEW_DURATION', duration)
      resolve()
    }).catch(error => {
      reject(error)
    })
  },
  setInterviewLanguage({ commit }, language) { // 新增：设置面试语言
    return new Promise((resolve, reject) => {
      commit('SET_INTERVIEW_LANGUAGE', language)
      resolve()
    }).catch(error => {
      reject(error)
    })
  },
  setPrompt({ commit }, prompt) {
    commit('SET_PROMPT', prompt)
  },
  setCameraSetting({ commit }, data) {
    const { usingBeautifys, usingFilter, usingBackground } = data
    return new Promise((resolve, reject) => {
      commit('SET_USING_BEAUTIFYS', usingBeautifys)
      commit('SET_USING_FILTER', usingFilter)
      commit('SET_USING_BACKGROUND', usingBackground)
      resolve()
    }).catch(error => {
      reject(error)
    })
  },
  setInterviewId({ commit }, id) {
    return new Promise((resolve, reject) => {
      commit('SET_INTERVIEW_ID', id)
      resolve()
    }).catch(error => {
      reject(error)
    })
  },
  startInterview({ commit }) {
    return new Promise((resolve, reject) => {
      commit('SET_INTERVIEW_STARTED', true)
      resolve()
    }).catch(error => {
      reject(error)
    })
  },
  setInterviewScore({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit('SET_INTERVIEW_SCORE', data)
      resolve()
    }).catch(error => {
      reject(error)
    })
  },
  stopInterview({ commit }) {
    return new Promise((resolve, reject) => {
      commit('SET_INTERVIEW_STARTED', false)
      resolve()
    }).catch(error => {
      reject(error)
    })
  },
  setJdCv({ commit }, data) {
    const { jd, cv } = data
    return new Promise((resolve, reject) => {
      commit('SET_JD', jd)
      commit('SET_CV', cv)
      resolve()
    }).catch(error => {
      reject(error)
    })
  },
  dialogueInteract({ commit }, data) {
    const { original_text, processed_text_from_llm } = data
    return new Promise((resolve) => {
      commit('SET_DIALOGUES', original_text)
      commit('SET_DIALOGUES', processed_text_from_llm)
      dispatch('formatDialogues').then(resolve) // 自动触发格式化
    })
  },
  clearDialogues({ commit }) {
    return new Promise((resolve, reject) => {
      commit('CLEAR_DIALOGUES')
      resolve()
    }).catch(error => {
      reject(error)
    })
  },
  dialogueFeedback({ commit }, data) {
    const { answer, feedback, question } = data
    return new Promise((resolve, reject) => {
      commit('SET_DIALOGUES', question)
      commit('SET_DIALOGUES', answer)
      commit('SET_DIALOGUES', feedback)
      resolve()
    }).catch(error => {
      reject(error)
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}